import * as React from "preact";
import { render } from "preact";
import utils from "../../helpers/utils";
import App from "./App";

function init(): void {
  const el = document.getElementById("regions-roles");

  if (el) {
    const {
      apiUrl,
      currentRegion,
      regionText,
      regionSelectLabel,
      currentRole,
      roleText,
      roleSelectLabel,
      ctaText,
      cancelCtaText,
      isSingleRegion,
      cookieText,
      cookieAcceptBtnLabel,
      cookieEditBtnLabel,
      cookieRejectAllBtnLabel,
      enableCookieScript,
    } = el.dataset;
    if (apiUrl) {
      render(
        <App
          apiUrl={apiUrl}
          // Key used to force this entire app to render again as if "new" when re-initialised, rather than keeping old state such as role/region from a previous time this modal was opened
          // More info: https://stackoverflow.com/questions/21749798/how-can-i-reset-a-react-component-including-all-transitively-reachable-state
          // Related bug: https://quilter.atlassian.net/secure/RapidBoard.jspa?rapidView=8&projectKey=PW&modal=detail&selectedIssue=PW-1529
          // Note: none of these props should need fallbacks as they're required in the CMS, but TypeScript is too strict for our use case!
          key={new Date().getTime()}
          initialRegion={currentRegion}
          regionText={regionText || "Region"}
          regionSelectLabel={regionSelectLabel || "Select region"}
          initialRole={currentRole}
          roleText={roleText || "Role"}
          roleSelectLabel={roleSelectLabel || "Select role"}
          ctaText={ctaText || "Go"}
          cancelCtaText={cancelCtaText || "Cancel"}
          isSingleRegion={utils.isStringTrue(isSingleRegion)}
          cookieText={cookieText}
          cookieAcceptBtnLabel={cookieAcceptBtnLabel}
          cookieEditBtnLabel={cookieEditBtnLabel}
          cookieRejectAllBtnLabel={cookieRejectAllBtnLabel}
          enableCookieScript={utils.isStringTrue(enableCookieScript)}
        />,
        el
      );
    }
  }
}
export default { init };
